import { render, staticRenderFns } from "./redConfig.vue?vue&type=template&id=184a9206&scoped=true&"
import script from "./redConfig.vue?vue&type=script&lang=js&"
export * from "./redConfig.vue?vue&type=script&lang=js&"
import style0 from "./redConfig.vue?vue&type=style&index=0&id=184a9206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a9206",
  null
  
)

export default component.exports